import { render, staticRenderFns } from "./download_nd.vue?vue&type=template&id=19e922aa&scoped=true&lang=pug&"
import script from "./download_nd.vue?vue&type=script&lang=js&"
export * from "./download_nd.vue?vue&type=script&lang=js&"
import style0 from "./download_nd.vue?vue&type=style&index=0&id=19e922aa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e922aa",
  null
  
)

export default component.exports